<template>
  <div class="commonHeadBox">
    <div class="headLeft">
      <div class="title">
        <img :src="headLogoImg2" alt="">
      </div>
      <div class="menuBox">
        <div v-for="(item,index) in menuList" :key="index" class="menuOne" :class="{activeMenu:menuId==item.id,'hoverFirstActive':item.id==hoverFirstActive}" @click="choiceMenu(item)" @mouseenter="mouseFirstEnter(item)"  @mouseleave="mouseFirstLeave(item)">
          <span class="menuName">{{ item.name }}</span>
          <div class="botColor" v-if="menuId==item.id || hoverFirstActive==item.id"></div>
          <div v-if="hoverFirstActive==item.id && item.children && item.children.length>0" class="secondTitleBox" @mouseleave="mouseSecondLeave">
            <div v-for="(it,idx) in item.children" :key="idx" class="secondOne" @click="secondClick(item,it)">
              <div class="secondName" :class="{activeSecondMenu:secondId==it.id}">{{ it.name }}</div>
              <div>{{ it.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex';
export default {
  name: 'maintopBar',
  components: {

  },
  computed: {
    ...mapState('Common', ['menuId','secondId']),
  },
  data(){
    return{
      hoverFirstActive:null,//一级菜单的hover
      headLogoImg:require('@/assets/img/common/headLogo.png'),
      headLogoImg2:require('@/assets/img/common/headLogo2.png'),
      menuList:[
        {id:1,name:'首页',url:'/index'},
        {id:2,name:'产品中心',url:'',children:[
          {id:'2-1',name:'数联电商生态平台',desc:'覆盖学业提升、职业发展、生活服务的数字化成长社区',url:'/productCenter/eCommercePlatform'},
          {id:'2-2',name:'数字化软硬件解决方案',desc:'数字化方案专家',url:'/productCenter/digitalSolutions'},
          {id:'2-3',name:'产教融合',desc:'专注产教融合推动教育与产业衔接',url:'/productCenter/inteIndustryEdu'},
          {id:'2-4',name:'数字竞赛服务',desc:'丰富的技术赛事，解决真实业务问题，在实战中成长',url:'/productCenter/digitalCompService'},
          {id:'2-5',name:'人力资源服务',desc:'致力于推动教育与产业无缝衔接',url:'/productCenter/humanResourceService'},
        ]},
        {id:3,name:'业务中心',url:'/businessCenter'},
        {id:4,name:'研究成果',url:'/scineResult'},
        // {id:5,name:'新闻中心',url:'/newsCenter'},
        {id:6,name:'关于我们',url:'/aboutAs'},
      ]

    }
  },
  methods:{
    ...mapActions("Common", [
      "set_menu_id",
      "set_second_id"
    ]),
    mouseFirstEnter(item){
      this.hoverFirstActive=item.id;
    },
    mouseFirstLeave(item){
      if(item.children==undefined || item.children.length==0){
        this.hoverFirstActive=null;
      }
    },
    mouseSecondLeave(){
      this.hoverFirstActive=null;
    },
    choiceMenu(item){
      this.set_menu_id(item.id);
      if(item.children==undefined || item.children.length==0){
        this.set_second_id(null);
        this.$router.push({path: item.url});
      }
    },
    secondClick(item,it){
      this.set_menu_id(item.id);
      this.set_second_id(it.id)
      this.$router.push({path: it.url});
    }
  }

}
</script>
<style lang="scss">
  .commonHeadBox{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height:73px;
    padding-left:96px;
    .headLeft{
      display: flex;
      align-items: center;
      .title{
        img{
          width:566px;
          height:40px;
          vertical-align: middle;
        }
        .sysTitle{
          margin-left:10px;
          font-size: 28px;
          color: #1D1D1D;
          vertical-align: middle;
          font-family: 'YouSheBiaoTiHei';
        }
      }
      .menuBox{
        display: flex;
        margin-left:54px;
        .menuOne{
          margin-right:54px;
          cursor: pointer;
          white-space: nowrap;
          font-size:24px;
          color: #1D1D1D;
          position:relative;
          .menuName{
            padding:0 6px;
          }
          .botColor{
            width:100%;
            height:4px;
            border-radius:2px;
            background: linear-gradient(to right, #68A5FF 0%, #E7ACFF 100%);
            margin-top:2px;
          }
          .secondTitleBox{
            position:absolute;
            left:-120px;
            top:58px;
            z-index:3;
            background:#fff;
            border-radius:10px;
            padding:28px 46px;
            box-shadow:0 0 2px 2px #ccc;
            .secondOne{
              margin-bottom:30px;
              &:last-child{
                margin-bottom:0;
              }
              &:hover{
                .secondName{
                  color:#3873FC;
                }
              }
              .activeSecondMenu{
                color:#3873FC;
              }
              >div{
                color: #707070;
                line-height:34px;
                &:first-child{
                  font-size:20px;
                  font-weight:bold;
                }
                &:last-child{
                  font-size:18px;
                  font-weight:400;
                }
              }
            }

          }
        }
        .activeMenu,.hoverFirstActive{
          font-weight: bold;
          color: #3873FC;
        }
      }
    }
  }
</style>

